import KeyFlowParamVO from './KeyFlowParamVO';

export type LibraryParamVOProps = {
  data: DataType[];
  user: string;
};

type TaskType = 'PARTIAL' | 'STREAMING' | 'LOGIN' | 'DOWNLOAD_FULL' | 'DOWNLOAD_PARTIAL' | 'DOWNLOAD_INTERVIEW' | 'DOWNLOAD_HIGHLIGHT';

type DataType = { ASSET_ID?: number; VIDEO_LIBRARY_ID?: number; TASK_TYPE: TaskType };

class StatisticsLogVO extends KeyFlowParamVO {
  data: DataType[];
  user: string;

  constructor(data: LibraryParamVOProps) {
    super();
    this.data = data.data;
    this.user = data.user;
  }
}

export default StatisticsLogVO;
